// src/components/Home.js
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Autocomplete, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print'
import { useReactToPrint } from 'react-to-print';
// import NumPad from 'react-numpad';
import TableTabs from '../Components/TableTabs';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import BeatLoader from "react-spinners/BeatLoader";
import CustomerDialog from '../Components/AddPetDialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { toast } from 'react-toastify';
function Billing() {

  const [isHovering, setIsHovering] = useState(false);
  const [bills, setBills] = useState([''])
  const [paymentMethod, setPaymentMethos] = useState('Cash')
  const [cash, setCash] = useState(0)
  const [open, setOpen] = useState(false);
  const [openDisc, setOpenDisc] = useState(false);
  const [discount, setDiscount] = useState(0)
  const [tempDisc, setTempDisc] = useState(0)
  const [invno, setInvNo] = useState()
  const [items, setItems] = useState([])
  const [total, setTotal] = useState(0)
  const [metaData, setMetaData] = useState({ user: JSON.parse(localStorage.getItem("emilia"))?.username,Total: total, Discount: discount,Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
  const [loading,setLoading] = useState(false)
  const [isSavingBill, setIsSavingBill] = useState(false)
  const [userDetails,setUserDetails]  = useState([])
  const [treatmentItems, setTreatmentItems] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [consumedUnits, setConsumedUnits] = useState('');

  const [animalData, setAnimalData] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);

  const [allItemsforBilling,setAllItemsForBilling] = useState([])

  const [loadingItems,setLoadingItems] = useState(true)


  // Returns

  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [returnBillNo, setReturnBillNo] = useState('');
  const [returnBillDetails, setReturnBillDetails] = useState([]);
  const [returnLoading, setReturnLoading] = useState(false);

  
  const navigate = useNavigate();

  useEffect(() => {
    if(!localStorage.getItem("emilia")){
      setLoading(true)
      navigate("/Login")
    }
    else{
      setUserDetails(JSON.parse(localStorage.getItem("emilia")))
      //console.log(JSON.parse(localStorage.getItem("emilia")))
      setLoading(false)
      }
      codeRef.current.focus();


      const getAlBillableItems = () =>{
        setLoadingItems(true)
        axios.get("https://serveremilia.mylksystems.com/Item/getItemDetailsforBilling").then(res => {
          setAllItemsForBilling(res.data)
          setLoadingItems(false)
        }).catch(e => {
          ////console.log(e)
        })
      }
    
      getAlBillableItems()
}, [])
  
  
  const getMax = () =>{
    setLoading(true)


      axios.get('https://serveremilia.mylksystems.com/billing/getmaxshop1').then(res =>{
        //console.log(res.data[0].inv_no)
        setInvNo(res.data[0].inv_no)
        setLoading(false)
      })
   
    

  }

  const [returnBills, setReturnBills] = useState([''])

  const getBills = () =>{
    setLoading(true)


      axios.get('https://serveremilia.mylksystems.com/billing/getshop1Bills').then(res =>{
        console.log(res.data)
        setReturnBills(res.data)

        
      })
   

  }


  const handleOpen = () => {
    setOpen(true);
    getMax()
    // setCash(0)
  };
  const handleOpenDisc = () => {
    setOpenDisc(true);
  };
  const handleClose = () => setOpen(false);
  const handleCloseDisc = () => setOpenDisc(false);

  const plusBtn = () => {
    setBills([...bills, ''])
  }


  const handleClick = () => {
    setDialogOpen(true);
  };

  const styles = {
    mainContainer :{
      backgroundColor : '#F5F5F5',
      width:'100%',
      // display : 'flex',
      justifyContent : 'center',
      margin : 10,
    },
    RightContainer : {
      backgroundColor :'white',
      // width : '60%',
      // width : '1050px',
      // height : '85vh',
      // padding : 10,
      // marginTop : -20,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      // marginLeft : 20
    },
    sidePanel: {
      // backgroundColor : 'yellow',
      // marginRight : -10
    },
    sidepnlBtn: {
      // boxShadow: '1px 1px 10px #1e1e1e'
      borderRadius: 10
      , display: 'flex'
      , flexDirection: 'column',
      alignItems: 'center'
    },
    BillBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      backgroundColor: isHovering ? 'white' : 'white',
      height: 50,
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10

    },
    PlusBtn: {
      boxShadow: '1px 1px 10px #1e1e1e',
      width: 35,
      borderRadius: 10
    },
    deleteBtn: {
      width: 25,
      marginLeft: 20,

    },
    billTable:{
      backgroundColor :'white',
      // width : '490px',
      height : '60vh',
      padding : 10,
      // boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius : 5,
      display : 'flex',
      flexDirection : 'column',
      borderTopLeftRadius : 0,
      justifyContent : 'space-between',
      overflow : 'auto',
      // marginLeft : 50,
      
    },
    paymentSelect: {
      width: '10wh',
      backgroundColor: 'white',
      padding: 10,
      boxShadow: '1px 1px 10px #1e1e1e',
      borderRadius: 5,
      marginTop: 20

    },
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      // width: 400,
      bgcolor: 'background.paper',
      border: '0px solid #000',
      boxShadow: 24,
      p: 4,
    }

    

  }



  useEffect(() => {

    var Total = 0.00

    for (let i = 0; i < items.length; i++) {
      Total = Total + parseFloat(items[i].Price) * parseFloat(items[i].qty)
    }

    setTotal(Total)
    codeRef.current.focus();

  }, [items])


  // const addToBill = (e) => {
  //   //console.log(e)
  //   if (items.length > 0) {
  //     let found = false;

  //     items.forEach((item, i) => {
  //       if (e.name === item.name) {
  //         ////console.log(item.qty)
  //         item.qty += 1;
  //         found = true;
  //         const updateItem = [...items];
  //         setItems(updateItem);
  //       }
  //     });

  //     if (!found) {
  //       const updateItem = [...items, e];
  //       setItems(updateItem);
  //     }
  //   } else {
  //     const updateItem = [...items, e];
  //     setItems(updateItem);
  //   }

  //   codeRef.current.focus();

  // }


  const handleModalSubmit = () => {
    if (consumedUnits && parseFloat(consumedUnits) > 0) {
      const unitPrice = parseFloat(modalItem.Price);
      const units = parseFloat(consumedUnits);
      const totalPrice = unitPrice * units;

      // Add the real item to treatmentItems
      const realItem = {
        ...modalItem,
        qty: units,
        totalPrice: totalPrice.toFixed(2),
      };
      setTreatmentItems((prevTreatmentItems) => [...prevTreatmentItems, realItem]);

      // Create or update the "Treatment Charges" item
      let found = false;

      const updatedItems = items.map((item) => {
        if (item.name === 'Treatment Charges') {
          found = true;
          const newPrice =
            parseFloat(item.Price) + totalPrice;
          return { ...item, Price: newPrice.toFixed(2) };
        }
        return item;
      });

      if (found) {
        setItems(updatedItems);
      } else {
        const newItem = {
          name: 'Treatment Charges',
          qty: 1,
          Price: totalPrice.toFixed(2),
        };
        setItems([...items, newItem]);
      }

      setShowModal(false);
      setModalItem(null);
      setConsumedUnits('');

      codeRef.current.focus();
    } else {
      alert('Please enter a valid number of units.');
    }
  };


  
  const addToBill = (e) => {

      if (items.length > 0) {
        let found = false;

        items.forEach((item, i) => {
          if (e.name === item.name) {
            item.qty += 1;
            found = true;
            const updateItem = [...items];
            setItems(updateItem);
          }
        });

        if (!found) {
          const updateItem = [...items, { ...e, qty: 1 }];
          setItems(updateItem);
        }
      } else {
        const updateItem = [...items, { ...e, qty: 1 }];
        setItems(updateItem);
      }

      codeRef.current.focus();
    
  };


  const resetBill = () => {

    items.forEach((item, i) => {
      ////console.log(item.qty)
      item.qty = 1;
      const updateItem = [...items];
      setItems(updateItem);
    });
    setIsHovering(false);
    setBills([''])
    setPaymentMethos('Cash')
    setCash(0)
    setOpen(false);
    setOpenDisc(false);
    setDiscount(0)
    setTempDisc(0)
    setInvNo()
    setItems([])
    setTreatmentItems([])
    setTotal(0)
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(localStorage.getItem("emilia"))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
    
    codeRef.current.focus();
  }


  const printsRef = useRef()

  const handlePrint = useReactToPrint({
    content: () => printsRef.current
  })


  const currentTime = new Date();
  const hours = formatTwoDigits(currentTime.getHours());
  const minutes = formatTwoDigits(currentTime.getMinutes());
  const seconds = formatTwoDigits(currentTime.getSeconds());

  function formatTwoDigits(value) {
    return value < 10 ? `0${value}` : value;
  }


  const returns = async () => {
    try {
      await getBills(); // Waits for getBills to complete
      console.log(returnBills);
      setReturnModalOpen(true); // Executes after getBills is done
    } catch (error) {
      console.error("Error fetching bills:", error);
      // Handle the error as needed
    }
  };

  const handleReturnClose = () => {
    setReturnModalOpen(false);
    setReturnBillNo('');
    setReturnBillDetails(null);
    codeRef.current.focus();
  };
  
  const handleReturnSubmit = () => {
    if (!returnBillNo) {
      toast.error('Please enter a bill number.');
      return;
    }
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }

    console.log(data)
    axios.post(`https://serveremilia.mylksystems.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  };

  const getReturnDetails = () =>{
    setReturnLoading(true);

    const data = {
      inv_no: returnBillNo,
    }
    axios.post(`https://serveremilia.mylksystems.com/billing/getBill`, data)
      .then(res => {
        setReturnBillDetails(res.data);
        console.log(res.data);
        setReturnLoading(false);
      })
      .catch(e => {
        toast.error('Bill not found.');
        setReturnLoading(false);
      });
  }
  

  
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = formatTwoDigits(currentDate.getMonth() + 1); // Months are zero-based, so we add 1
  const day = formatTwoDigits(currentDate.getDate());
  const hour = formatTwoDigits(currentDate.getHours());
  const minute = formatTwoDigits(currentDate.getMinutes());
  const second = formatTwoDigits(currentDate.getSeconds());
  const invoiceNo = `${year}${month}${day}${hour}EM${invno}`;
  
  // ////console.log(metaData)

  useEffect(() => {
    setMetaData({ Total: total, Discount: discount, user: JSON.parse(localStorage.getItem("emilia"))?.userName, Method: paymentMethod, Amount: paymentMethod === 'Card' ? total : cash })
    // codeRef.current.focus();
  }, [bills, cash, discount, paymentMethod, total])

  const toPrint = async () => {
    if (isSavingBill) {
      return;
    }

    if (!invno) {
      toast.error('Invoice number is not ready. Please try again.');
      return;
    }

    // Combine items and treatmentItems, excluding "Treatment Charges" from items
    const individualItems = items.filter(item => item.name !== 'Treatment Charges');
    const allItems = individualItems.concat(treatmentItems);

    if (allItems.length === 0) {
      toast.error('No items available to bill.');
      return;
    }

    // //console.log("all items",allItems)
    // Create an array to hold the models
    const models = [];

    // Loop through allItems to create the model for each item
    allItems.forEach((e, i) => {
      const model = {
        invoice_no: invoiceNo,
        cashier: JSON.parse(localStorage.getItem("emilia"))?.username,
        bill_date: `${year}-${month}-${day}`,
        bill_time: `${hours}:${minutes}`,
        product_name: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
        unit_price: parseFloat(e.Price) || parseFloat(e.totalPrice) || 0,
        gross_total: metaData.Total,
        discount: metaData.Discount,
        net_total: metaData.Total - metaData.Discount,
        paymentMethod: metaData.Method,
        cash_amount: metaData.Amount,
        Balance: metaData.Amount - (metaData.Total - metaData.Discount),
        Item_ID: e.ItemID, // Use e._id if available, otherwise e.ItemID
        product_category_id: e.ItemCategoryID,
        store: 'Mirigama',
        stockid : e.stockId
      };

      // Add the model to the models array
      models.push(model);
    });

    // Now models is an array of item models
    // //console.log('Models:', models);

    // Create billingData with items as models array
    const billingData = {
      inv_no: invoiceNo,
      username: JSON.parse(localStorage.getItem("emilia"))?.username,
      inv_date: `${year}-${month}-${day}`,
      gross_total: metaData.Total,
      discount: metaData.Discount,
      net_total: metaData.Total - metaData.Discount,
      shop: 'Mirigama',
      paymentMethod: metaData.Method,
      items: models, // Include the models array here
    };

    // Log billingData to verify
    // //console.log('Billing Data:', billingData);

    // Now create stockUpdateData
    const stockUpdateItems = [];

    allItems.forEach((e, i) => {

      const stockItem = {
        itemId: e._id || e.ItemID, // Use e._id if available, otherwise e.ItemID
        itemCategoryId: e.ItemCategoryID,
        itemName: e.name,
        qty: parseInt(e.qty) || parseInt(e.units) || 1,
      };

      stockUpdateItems.push(stockItem);
    });

    const stockUpdateData = {
      items: stockUpdateItems,
    };

    // Log stockUpdateData to verify
    // //console.log('Stock Update Data:', stockUpdateData);
    setIsSavingBill(true);
    try {
      await axios.post('https://serveremilia.mylksystems.com/billing/CreateShop1Invoice', billingData);

      try {
        await axios.post('https://serveremilia.mylksystems.com/stock/BillShop1Items', stockUpdateData);
      } catch (stockError) {
        console.error('Stock update failed after invoice save:', stockError);
        toast.warning('Bill saved, but stock update failed. Please check stock.');
      }

      await handlePrint();
      resetBill();
    } catch (error) {
      console.error('Invoice creation failed:', error);
      toast.error('Bill was not saved. Printing cancelled.');
    } finally {
      setIsSavingBill(false);
    }

  }


  const changeQtyMinus = (e) => {
    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (e.name === item.name) {
          ////console.log(item.qty)
          item.qty -= 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem);
    }

  }




  const changeQtyPlus = (e) => {
    if (items.length > 0) {
      let found = false;

      items.forEach((item, i) => {
        if (e.name === item.name) {
          ////console.log(item.qty)
          item.qty += 1;
          found = true;
          const updateItem = [...items];
          setItems(updateItem);
        }
      });

      if (!found) {
        const updateItem = [...items, e];
        setItems(updateItem);
      }
    } else {
      const updateItem = [...items, e];
      setItems(updateItem); 
    }

  }

  const addDiscount = () => {
    setDiscount(parseInt(discount) + parseInt(tempDisc))
    handleCloseDisc()

  }

  const deleteItem = (e) => {
    setItems(items.filter(item => item.name !== e))
    if(items.length-1 < 1){
      setDiscount(0)
    }
    codeRef.current.focus();
  }



  const makeReturn = (billDetails) => {

    console.log(billDetails);

   const shop = JSON.parse(localStorage.getItem("emilia"))?.shop;

     axios.post('https://serveremilia.mylksystems.com/billing/return1',billDetails).then((res) => {
       toast.error('Return Successful');
       getReturnDetails()
       codeRef.current.focus();
     });
   



  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      allItemsforBilling.map((e,i) => {
        //console.log("ItemId",e.ItemID)
        //console.log("codeRef.current.value",codeRef.current.value)
        if(parseInt(e.ItemID) === parseInt(codeRef.current.value)){
          //console.log(e)
          const itemDetails = e;
          itemDetails.name = e.ItemName
          itemDetails.Price = e.sellingPrice
          addToBill(itemDetails)
          codeRef.current.value = "";
        }
        
      })

    }
  };


  const codeRef = useRef(null);

  const handleQtyChange = (index, newQty) => {
    // Ensure the newQty is within the bounds (1 to e.qty)
    const updatedQty = Math.min(Math.max(newQty, 1), returnBillDetails[index].qty); 
  
    // Update the returnBillDetails array (use a copy of the array to trigger re-render)
    setReturnBillDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        returnQty: updatedQty,  // Store the updated return quantity
      };
      return updatedDetails;
    });
  };
  


  return (
    <>
      <CustomerDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
  {modalItem && (
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setModalItem(null);
          setConsumedUnits('');
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Enter Consumed Units
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Base Unit Price: {modalItem.Price} {' '}
            {modalItem.ItemCategoryID === 1 ? 'per ml' : modalItem.ItemCategoryID === 18 ? '':'per g'}
          </Typography>
          <TextField
            autoFocus
            label="Consumed Units"
            type="number"
            value={consumedUnits}
            onChange={(e) => setConsumedUnits(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleModalSubmit();
              }
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleModalSubmit}
              sx={{ mr: 1 }}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setShowModal(false);
                setModalItem(null);
                setConsumedUnits('');
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    )}
    <Grid container spacing={2} style={{ height: '100%',marginTop:0,fontFamily:'Arial',display:'flex',justifyContent:'center',flexDirection:'row',}}>
      <Grid item xs= {12} md={4}>
        <Paper style={{ backgroundColor: 'white', height: '100%',marginLeft:10,paddingLeft:10,paddingRight:10,marginBottom:10,marginTop : 50}}>
        <Box display="flex" alignItems="center">
          {loadingItems ? <BeatLoader /> : null}
          <TextField
            id="standard-basic"
            label="Item-Code"
            variant="standard"
            onKeyPress={handleKeyPress}
            inputRef={codeRef}
            autoComplete="off"
            sx={{ flexGrow: 1, marginRight: 1 }}
          />
        

          <Button
            variant="contained"
            style={{
              backgroundColor: '#000000',
              color: 'white',
              fontWeight: 'bold',
              fontSize: 14
            }}
            onClick={returns} // Updated to open modal
          >
            RETURNS
          </Button>

    </Box>
        <Box xs ={2} width={'100%'}>
            {/* bill */}
            <div style={styles.billTable}>
              <table width={'100%'}>
                <tr style={{backgroundColor : 'white',fontSize:18}} >
                  <th align='left'></th>
                  <th align='left'>Item</th>
                  <th align='center'>Qty</th>
                  <th align='center'>Price</th>
                  <th style={{textAlign : 'center'}}>Total</th>
                </tr>
                <tr style={{backgroundColor : 'White',fontSize:18}}>
                  <td align='center' colSpan={6}><hr></hr></td>
                </tr>
                {/* {items.slice().reverse().map((e,i) =>(
                  <>
                  <tr style={{fontSize:18,fontFamily : 'consolas'}}>
                    <td align='left'>{i+1}).</td>
                    <td align='left' width={100} colSpan={5}>{e.name}</td>
                  </tr>


                  <tr style={{backgroundColor : 'white',borderBottom : '2px solid black'}}>
                    <td></td>
                    <td></td>
                    <td align='center' style={{fontWeight : 'bold'}}>{ e.qty > 1 ? <button onClick={() =>{changeQtyMinus(e)}} style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginRight:10,backgroundColor: '#000000',color: 'white',fontSize :18}}>-</button>:<><button style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginRight:10,backgroundColor: '#000000',color: 'white',fontSize :18}}>-</button></>}{e.qty}<button onClick={() =>{changeQtyPlus(e)}} style={{borderRadius : 50,borderWidth : 0,height:30,width:30,fontWeight : 'bold',marginLeft:10,fontSize :18,backgroundColor: '#000000',color: 'white'}}>+</button></td>
                    <td align='center' style={{fontWeight : 'bold'}}>{e.Price}</td>
                    <td align='Right' onClick={handleOpenDisc} style={{fontWeight : 'bold'}}>{e.Price*e.qty}.00</td>
                    <td>
                    <img src ={require('../Assests/delete.png')} alt = 'billImage' style={styles.deleteBtn} width={20} onClick={() => {setItems(items.filter(item => item.name !== e.name)); setTotal(total-parseFloat(e.Price)); codeRef.current.focus();}}></img>
                    </td>
                    <td>
                    <img src ={require('../Assests/exchange.png')} alt = 'billImage' style={styles.deleteBtn} width={10} onClick={() => { setTotal(total-parseFloat(e.Price)); codeRef.current.focus();}}></img>
                    </td>

                  </tr>
                  </>
                ))} */}


{items.slice().reverse().map((e, i) => (
  <>
    <tr style={{ fontSize: 18, fontFamily: 'Consolas' }}>
      <td align='left'>{i + 1}).</td>
      <td align='left' width={100} colSpan={5}>{e.name}</td>
    </tr>

    <tr style={{ backgroundColor: 'white', borderBottom: '2px solid black' }}>
      <td></td>
      <td></td>
      <td align='center' style={{ fontWeight: 'bold' }}>
        {e.qty > 1 ? (
          <button
            onClick={() => { changeQtyMinus(e) }}
            style={{
              borderRadius: 50, borderWidth: 0, height: 30, width: 30,
              fontWeight: 'bold', marginRight: 10, backgroundColor: '#000000',
              color: 'white', fontSize: 18
            }}>-</button>
        ) : (
          <button style={{
            borderRadius: 50, borderWidth: 0, height: 30, width: 30,
            fontWeight: 'bold', marginRight: 10, backgroundColor: '#000000',
            color: 'white', fontSize: 18
          }}>-</button>
        )}
        {e.qty}
        <button
          onClick={() => { changeQtyPlus(e) }}
          style={{
            borderRadius: 50, borderWidth: 0, height: 30, width: 30,
            fontWeight: 'bold', marginLeft: 10, fontSize: 18, backgroundColor: '#000000',
            color: 'white'
          }}>+</button>
      </td>
      <td align='center' style={{ fontWeight: 'bold' }}>{e.Price}</td>
      <td align='Right' onClick={handleOpenDisc} style={{ fontWeight: 'bold' }}>{e.Price * e.qty}.00</td>
      <td>
        <img
          src={require('../Assests/delete.png')}
          alt='billImage'
          style={styles.deleteBtn}
          width={20}
          onClick={() => {
            setItems(items.filter(item => item.name !== e.name));
            setTotal(total - (e.Price * e.qty));  // Remove item total from total
            codeRef.current.focus();
          }}
        />
      </td>
      <td>
        <img
          src={require('../Assests/exchange.png')}
          alt='billImage'
          style={styles.deleteBtn}
          width={10}
          onClick={() => {
            setItems(items.map(item => {
              if (item.name === e.name) {
                if (!item.name.includes('- ex')) {
                  return { 
                    ...item, 
                    name: `${item.name} - ex`, 
                    Price: -Math.abs(item.Price)
                  };
                }
              }
              return item;
            }));
            codeRef.current.focus();

          }}
        />
      </td>
    </tr>
  </>
))}
              </table> 
            </div>
        <div style={{fontSize: 40,color: 'Black',fontWeight : 'bold',marginTop:10}}>
          <div>
            Total  Rs.<label style={{ color: 'gray' }}>  {total}.00</label><br></br>
          </div>
          {/* <div style={{ fontSize: 30, color: 'gray' }}>
            Discount Rs.<label style={{ color: 'gray' }}>  {discount}.00</label><br></br>
          </div> */}
         </div>
         <div >
          {items.length > 0 && total >= 0 ? <>
            <button style={{width : '100%',fontSize :30,height :65,marginTop:10,fontWeight : 'bold',backgroundColor : '#00B912',borderRadius : 5,borderWidth : 0,color:"white",display:'flex',justifyContent:'center',alignItems:'center'}} onClick={handleOpen}>
                Pay Rs.{total-discount}.00
              <img src ={require('../Assests/cash.png')} alt = 'billImage'  style = {{width : 45,marginLeft : 10}}></img>
            </button></>:<>
            <button style={{width : '100%',fontSize :30,height :65,marginTop:10,fontWeight : 'bold',backgroundColor : 'gray',borderRadius : 5,borderWidth : 0,color:"white"}}>
                Pay Rs.{total-discount}.00
              <img src ={require('../Assests/cash.png')} alt = 'billImage'  style = {{width : 45,marginLeft : 10,marginTop:-10}}></img>
            </button></>}
        </div>
      </Box>
        </Paper>
      </Grid>
      <Grid item xs = {12} md={8}>
        <Paper style={{ backgroundColor: 'white', height: '100%',marginRight:10 , marginTop : 50}}>
          <TableTabs bill = {addToBill}/>
        </Paper>
      </Grid>
    </Grid>

    <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Payment Methods
            </Typography>
            <div>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="paymentMethod"
                onChange={(e) => { setPaymentMethos(e.target.value) }}
                value={paymentMethod}
              >
                <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                <FormControlLabel value="Card" control={<Radio />} label="Card" />
              </RadioGroup>
            </div>
            {paymentMethod === 'Cash' ? (
  <div
    style={{
      margin: 10,
      display: 'flex',
      height: '35vh',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
    }}
  >
    <Typography
      id="modal-modal-description"
      style={{ fontSize: 35, color: 'green' }}
    >
      Total : Rs.{total - discount}.00
    </Typography>
    <Typography
      id="modal-modal-description"
      style={{
        fontSize: 25,
        color: cash - (total - discount) < 0 ? 'red' : 'blue',
      }}
    >
      {cash - (total - discount) < 0 ? (
        <>Balance : -- --</>
      ) : (
        <>Balance : Rs. {cash - (total - discount)}.00</>
      )}
      <hr />
    </Typography>

    <TextField
      id="standard-basic"
      onChange={(e) => {
        setCash(e.target.value);
      }}
      type="number"
      autoComplete="off"
      onKeyDown={(e) => {
        if (e.key === 'Enter' && cash - (total - discount) >= 0 && !isSavingBill) {
          toPrint();
        }
      }}
    />

    <div style={{ fontSize: 25, alignItems: 'center' }}></div>

    {loading && paymentMethod === 'Cash' ? (
      <center>
        <BeatLoader color="#28968E" />
      </center>
    ) : (
      <>
        {cash - (total - discount) < 0 ? (
          <Button
            style={{
              width: '100%',
              height: 80,
              fontSize: 30,
              marginTop: 15,
              fontWeight: 'bold',
              backgroundColor: '#A7A7A7',
              borderRadius: 5,
              color: 'black',
            }}
            disabled
            variant="contained"
            startIcon={<PrintIcon style={{ fontSize: 40 }} />}
          >
            PRINT
          </Button>
        ) : (
          <Button
            style={{
              width: '100%',
              height: 80,
              fontSize: 30,
              marginTop: 15,
              fontWeight: 'bold',
              backgroundColor: '#0029FF',
              borderRadius: 5,
              color: 'white',
            }}
            onClick={toPrint}
            disabled={isSavingBill}
            variant="contained"
            startIcon={<PrintIcon style={{ fontSize: 40 }} />}
          >
            {isSavingBill ? 'SAVING...' : 'PRINT'}
          </Button>
        )}
      </>
    )}
  </div>
) : (
  <div
    style={{
      margin: 10,
      display: 'flex',
      height: '20vh',
      flexDirection: 'column',
      justifyContent: 'space-around',
    }}
  >
    <Typography
      id="modal-modal-description"
      style={{ fontSize: 35, color: 'green' }}
    >
      Total : Rs.{total - discount}.00
    </Typography>

    {loading ? (
      <center>
        <BeatLoader color="#28968E" />
      </center>
    ) : (
      <Button
        style={{
          width: '100%',
          height: 80,
          fontSize: 30,
          marginRight: 5,
          fontWeight: 'bold',
          backgroundColor: '#0029FF',
          borderRadius: 5,
          color: 'white',
        }}
        onClick={toPrint}
        disabled={isSavingBill}
        variant="contained"
        startIcon={<PrintIcon style={{ fontSize: 40 }} />}
      >
        {isSavingBill ? 'SAVING...' : 'PRINT'}
      </Button>
    )}
  </div>
)}



          </Box>
        </Modal>
      </div>



      <div>
      <Modal
        open={openDisc}
        onClose={handleCloseDisc}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
        <Box sx={styles.style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Discount Amount :
          </Typography>
          <br></br>
          <br></br>

          <TextField
            id="standard-basic"
            label="Discount in Rs."
            variant="standard"
            onChange={(e) => setDiscount(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                addDiscount();
              }
            }}
            type="number"
            autoComplete="off"
          />
          <br></br>
          <br></br>

          <div style={{ fontSize: 20 }}>
            <br></br>
            <br></br>
            <Button variant="outlined" onClick={() => addDiscount()} style={{ width: 300 }}>
              Add Discount
            </Button>
          </div>
        </Box>

      </Modal>
      {/* Bill */}
      <div style={{ display: 'none', position: 'relative', zIndex: 1000, justifyContent: 'center', top: 0, left: 0, width: '100%', height: '100%', alignItems: 'center' }}>
  <table border={0} width={'100'} style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold', fontSize: 10 }} id='BillingDoc' ref={printsRef}>
    <tr>
      <td colSpan={4} align='center'>
        <img src={require('../Assests/billLogo.png')} alt='' width={100} style={{ marginBottom: 0 }} />
      </td>
    </tr>
    <tr>
      <td colSpan={4} align='center' style={{ fontSize: 12, fontWeight: 'bold' }}>
        <label style={{ fontSize: 14 }}>Emilia - Clothing</label><br />
        No 10 Main Street,<br />
        Mirigama<br />
        Tel. (074) 223 9972
      </td>
    </tr>
    <tr>
      <td colSpan={4} align='right'>-----------------------------</td>
    </tr>
    <tr>
      <td colSpan={4} align='left' style={{fontSize:14}}>Cashier: {JSON.parse(localStorage.getItem("emilia"))?.username}</td>
    </tr>
    <tr>
      <td colSpan={4} align='left' style={{fontSize:14}}>Date: {`${year}-${month}-${day}`}</td>
    </tr>
    <tr>
      <td colSpan={4} align='left' style={{fontSize:14}}>Inv: {invoiceNo}</td>
    </tr>
    <tr>
      <td colSpan={4} align='right'>-----------------------------</td>
    </tr>

    {items?.map((e, i) => (
      <>
        <tr style={{fontSize:14}}>
          <td align='right'>{i + 1}.</td>
          <td colSpan={3}>{e.name}</td>
        </tr>
        <tr style={{ backgroundColor: 'white',fontSize:14 }}>
          <td></td>
          <td align='right'>{e.qty}</td>
          <td align='center' colSpan={1}>{e.Price}</td>
          <td align='right'>{e.qty * e.Price}.00</td>
        </tr>
      </>
    ))}

    <tr>
      <td colSpan={4} align='right'>-----------------------------</td>
    </tr>
    <tr>
      <td colSpan={4} align='right' style={{ backgroundColor: 'white',fontSize:14 }}>Gross: Rs.{metaData?.Total}.00</td>
    </tr>
    <tr>
      <td colSpan={4} align='right' style={{ backgroundColor: 'white',fontSize:14 }}>Discount: Rs.({metaData?.Discount}.00)</td>
    </tr>
    <tr>
      <td colSpan={4} align='right'>-----------------------------</td>
    </tr>
    <tr>
      <td colSpan={3} align='left' style={{ fontWeight: 'bold',fontSize:14  }}>Total</td>
      <td colSpan={1} align='right' style={{ fontWeight: 'bold',fontSize:14  }}>Rs.{metaData?.Total - metaData?.Discount}.00</td>
    </tr>
    <tr>
      <td colSpan={4} align='right'>==========</td>
    </tr>
    <tr>
      <td colSpan={3} align='left' style={{ backgroundColor: 'white',fontSize:14 }}>{metaData?.Method}</td>
      <td colSpan={1} align='right' style={{ backgroundColor: 'white',fontSize:14 }}>
        Rs.{metaData?.Method === 'Card' ? metaData?.Amount - metaData?.Discount : metaData?.Amount}.00
      </td>
    </tr>
    <tr>
      <td colSpan={3} align='left' style={{ backgroundColor: 'white',fontSize:14 }}>Balance</td>
      <td colSpan={1} align='right' style={{ backgroundColor: 'white',fontSize:14 }}>
        Rs.{metaData?.Method === 'Card' ? '00.00' : metaData?.Amount - (metaData?.Total - metaData?.Discount)}
      </td>
    </tr>
    <tr>
      <td colSpan={4} align='center' style={{ fontSize: 10 }}>Exchange Only Accept within 7 days with receipt</td>
    </tr>
    <tr>
      <td colSpan={4} align='center'>-----------------------------</td>
    </tr>
  </table>
</div>

{/* Return Model */}
      <Modal
        open={returnModalOpen}
        onClose={handleReturnClose}
        aria-labelledby="return-modal-title"
        aria-describedby="return-modal-description"
      >
        <Box sx={styles.style}>
          <Typography id="return-modal-title" variant="h6" component="h2">
            Return Bill Details for Emilia
          </Typography>
         
            <div>
              <Grid container spacing={1}>
                <Grid xs = {12} md = {12}>
                  <div style={{ display: 'flex', justifyContent: 'space-between',margin : 20 }}>

                  <Autocomplete
                    options={returnBills} // Pass the entire array of bill objects
                    getOptionLabel={(option) => option.inv_no || ''} // Extract 'inv_no' for display
                    value={
                      returnBills.find((bill) => bill.inv_no === returnBillNo) || returnBillNo || ''
                    } // Set the value to the selected bill object or the entered string
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        // User typed a bill number
                        setReturnBillNo(newValue);
                      } else if (newValue && newValue.inv_no) {
                        // User selected a bill from the dropdown
                        setReturnBillNo(newValue.inv_no);
                      } else {
                        // Handle cases like clearing the input
                        setReturnBillNo('');
                      }
                    }}
                    freeSolo // Allow users to enter values not present in the list
                    renderOption={(props, option) => (
                      <li {...props} key={option.inv_no}>
                        {option.inv_no}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Enter Bill Number"
                        variant="standard"
                        fullWidth
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleReturnSubmit();
                          }
                        }}
                      />
                    )}
                    noOptionsText="No matching bill numbers"
                    style={{ width: 300 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleReturnSubmit}
             
                    style={{marginLeft: 20,fontSize:15}}
                    >
                    Search
                  </Button>
                    </div>
                    <hr></hr>

                    <Grid xs = {12} md = {12}>
                        <div>
                          {/* Display the bill details */}
                          <TableContainer
      component={Paper}
      style={{
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        height: 400, // Set the maximum height for the container
        overflowY: 'auto',  // Enable vertical scrolling
      }}
    >
      <Table stickyHeader style={{ minWidth: 650 }} >
        <TableHead>
          <TableRow style={{ backgroundColor: '#000000' }}>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#000000' }}>Invoice No</TableCell>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#000000' }}>Item Name</TableCell>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#000000' }}>Return Qty</TableCell>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#000000' }}>Line Total</TableCell>
            <TableCell style={{ color: 'White', fontWeight: 'bold',backgroundColor : '#000000' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {returnBillDetails?.map((e, i) => (
            <TableRow key={i} style={i % 2 === 0 ? { backgroundColor: '#f9f9f9' } : {}}>
              <TableCell>{e.inv_no}</TableCell>
              <TableCell>{e.item_name}</TableCell>

              {/* Editable qty field */}
              <TableCell>
                <input
                  type="number"
                  value={e.returnQty || e.qty}  // Default to e.qty if no returnQty is set
                  min="1"
                  max={e.qty}  // Prevent the return quantity from exceeding the total purchased quantity
                  onChange={(event) => handleQtyChange(i, event.target.value)}
                  style={{ width: '50px', textAlign: 'center', height: 30, fontSize: 20 }}
                />
              </TableCell>

              <TableCell>{e.total}</TableCell>

              {e.total === 0.00 || e.billed_name === 'Treatment Charges' || e.qty === 0 ? (
                <TableCell><Button disabled>Not Applicable</Button></TableCell>
              ) : (
                <TableCell><Button onClick={() => makeReturn(e)}>Return</Button></TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
                          {/* <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleReturnClose}
                            sx={{ mt: 2 }}
                          >
                            Close
                          </Button> */}
                        </div>
                    </Grid>



                </Grid>

                

              </Grid>
            </div>
         
         
          {returnLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <BeatLoader color="#000000" />
            </Box>
          )}
        </Box>
      </Modal>

    </div>
    </>
  )
}

export default Billing



